import { queryOptions } from "@tanstack/react-query";

import { getSuppressionsView } from "./server";

export function suppressionsQueryKey(search?: string) {
  return ["suppressions", { search: search?.trim() || undefined }] as const;
}

export function suppressionsQueryOptions(search?: string) {
  return queryOptions({
    queryKey: suppressionsQueryKey(search),
    queryFn: () => getSuppressionsView({ data: { search } }),
    staleTime: 15_000,
  });
}
